import { createRoot, hydrateRoot } from "react-dom/client";
import App, { preloadRoute } from "./App";
import "./index.css";
import { initWebVitals } from "./lib/webVitals";

const container = document.getElementById("root")!;

if (container.childElementCount > 0) {
  // Load this route's code-split chunk first so the first client render
  // matches the prerendered HTML and React can hydrate instead of
  // throwing it away and re-rendering.
  preloadRoute(window.location.pathname)
    .catch(() => undefined)
    .finally(() => hydrateRoot(container, <App />));
} else {
  createRoot(container).render(<App />);
}

// Report Core Web Vitals to GA4 once the app is on screen.
initWebVitals();
